module.exports = __webpack_public_path__ + "static/media/tense-nervous.db7364f7.png";